import { render, staticRenderFns } from "./OzlukListesi.vue?vue&type=template&id=c544c174&scoped=true&"
import script from "./OzlukListesi.vue?vue&type=script&lang=js&"
export * from "./OzlukListesi.vue?vue&type=script&lang=js&"
import style0 from "./OzlukListesi.vue?vue&type=style&index=0&id=c544c174&lang=scss&scoped=true&"
import style1 from "./OzlukListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c544c174",
  null
  
)

export default component.exports